import React from 'react';
import './index.scss';

const NoData = ({
  totalColumn,
  text,
  children
}) => {
  return /*#__PURE__*/React.createElement("tr", {
    "data-purpose": "no-data"
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: totalColumn
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-no-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-no-data-content"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-inbox empty-icon"
  }), /*#__PURE__*/React.createElement("div", null, text), children))));
};

NoData.defaultProps = {
  text: 'No records to display'
};
export default NoData;